module.exports = __webpack_public_path__ + "img/bgc.0b89c749.png";